import {
  useGetNotificationCountsQuery,
  useGetNotificationPreferencesQuery
} from '@axilon-apps/domains-ontology-ui-state'

const POLLING_INTERVAL_MS = 30_000

export interface NotificationCounts {
  /** Open Needs-you rows for the caller. Drives the badge number. */
  needsYouCount: number
  /** Needs-you rows the caller has not read yet. */
  needsYouUnread: number
  /** Unread activity; a quiet dot when the caller shows activity. */
  activityUnread: number
  /** Kept for existing callers: the badge number. */
  importantCount: number
  hasUnreadInfo: boolean
}

/**
 * Badge and tab counts from the server. Only Needs you counts toward the
 * badge; activity shows a dot, and only when the person keeps activity in
 * the bell.
 */
export function useNotificationCounts(): NotificationCounts {
  const { data } = useGetNotificationCountsQuery(undefined, {
    pollingInterval: POLLING_INTERVAL_MS
  })
  const { data: prefs } = useGetNotificationPreferencesQuery()
  const needsYouCount = data?.needs_you ?? 0
  const activityUnread = prefs?.show_activity === false ? 0 : (data?.activity_unread ?? 0)
  return {
    needsYouCount,
    needsYouUnread: data?.needs_you_unread ?? 0,
    activityUnread,
    importantCount: needsYouCount,
    hasUnreadInfo: activityUnread > 0
  }
}
